import { ReactElement, memo, useCallback } from 'react';
import { GroupTypeBase, MenuListComponentProps } from 'react-select';
import { useStoreActions, useStoreState } from '~/store/hooks';
import { IOption } from '~/ui/components/inputs/Select/types';
import SelectAll from '~/ui/components/inputs/SelectWithoutAnimation/components/SelectAll';

const NewMenuList = ({
  children,
  ...props
}: MenuListComponentProps<IOption, boolean, GroupTypeBase<IOption>>): ReactElement => {
  const { excluded, isAllSelected, list } = useStoreState(
    store => store.client.clientOptionsByTeam,
  );
  const { setCurrentClientOption, setAllClientOptionByTeam, setExcludedClientOption } =
    useStoreActions(action => action.client);

  const selectAll = isAllSelected && !excluded.length;

  const setAll = useCallback(
    (all?: boolean) => {
      if (all) {
        setAllClientOptionByTeam(true);
        setExcludedClientOption([]);
        setCurrentClientOption(list);
      } else {
        setAllClientOptionByTeam(false);
        setCurrentClientOption([]);
        setExcludedClientOption([]);
      }
    },
    [list, setAllClientOptionByTeam, setCurrentClientOption, setExcludedClientOption],
  );

  return (
    <SelectAll {...props} selectAll={selectAll} setSelectAll={setAll}>
      {children}
    </SelectAll>
  );
};

export default memo(NewMenuList);
